export { Comparison, useComparison } from './ui/Comparison';
export {
  comparisonReducer,
  addToComparisonThunk,
  removeFromComparisonThunk,
  updateComparisonList
} from './model/slice/comparisonSlice';
